<template>
  <div class="jira-cloud-step-1">

    <div class="row mb-3">
      <div class="col-12">
        <h2>Project Selection</h2>

      </div>
      <div class="col-12">
        <p>Please choose one project</p>
      </div>
    </div>

    <div class="row jira-feature-headline jf-row">
      <div class="col-6">
        <div class="jfh-col metastory">

          <div class="icon">
            <img class="metastory-logo light" src="@/assets/ui/text-cursor.svg" style="width: 6px;">
            <img class="metastory-logo dark" src="@/assets/ui/text-cursor-white.svg" style="width: 6px;">
          </div>
          metastory Projects
        </div>
      </div>
      <div class="col-6">
        <div class="jfh-col jira">
          <div class="icon">
            <img src="@/assets/integrations/jira.svg" style="height: 16px;">
          </div>
          Jira Projects
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <ul class="project-list scrollbar">
          <div class="loading-list" v-if="isLoading">
            <LucideIcon class="fa-spin-animation" icon="LoaderCircle"/>
            Fetching projects
          </div>
          <li
              class="project-item"
              v-for="project in allWorkspaceProjects"
              :key="project.id"
              @click="selectedMSProject = project"
              :class="[selectedMSProject.id === project.id ? 'selected' : '']"
          >
            {{ project.name }}
            <LucideIcon v-if="selectedMSProject.id === project.id" icon="Check"/>
          </li>
        </ul>
      </div>
      <div class="col-6">
        <ul class="project-list scrollbar">
          <div class="loading-list" v-if="isLoading">
            <LucideIcon class="fa-spin-animation" icon="LoaderCircle"/>
            Fetching projects
          </div>

          <li
              class="project-item"
              v-for="project in jiraProjectList"
              :key="project.id"
              @click="selectedJiraProject = project"
              :class="[selectedJiraProject.id === project.id ? 'selected' : '']"
          >
            {{ project.name }}
            <LucideIcon v-if="selectedJiraProject.id === project.id" icon="Check"/>
          </li>
        </ul>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="config-footer flex-end">
          <div class="button-group">
            <ButtonElement class="btn--ms btn--silent-tertiary btn--regular" @click="$emit('cancelClick')">Back</ButtonElement>
            <ButtonElement class="btn--ms btn--accent"
                           @click="clickContinue()"
                           :is-disable="!this.selectedMSProject.id || !this.selectedJiraProject.id">Continue
            </ButtonElement>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script lang="ts">
import {defineComponent} from 'vue'
import ButtonElement from '@shared/components/elements/button/button.element.vue'
import {IntegrationNs, ProjectNs} from '@shared/types'
import {mapStores} from "pinia";
import {useWorkspaceStore} from "@shared/stores/workspace.store";
import {useIntegrationStore} from "@domains/settings/stores/integration.store";


export default defineComponent({
  name: 'JiraCloudStep2',
  components: {
    ButtonElement
  },
  emits: ['cancelClick', 'continueClick'],
  computed: {
    ...mapStores(useWorkspaceStore, useIntegrationStore),
  },
  data() {
    return {
      isLoading: false,
      allWorkspaceProjects: [] as ProjectNs.Project[],
      selectedMSProject: {} as ProjectNs.Project,
      jiraProjectList: [] as ProjectNs.Project[],
      selectedJiraProject: {} as ProjectNs.Project,
      selectedOption: 'option1',
    }
  },
  beforeMount() {
    this.isLoading = true;
    const workspace = this.workspaceStore.getSelectedWorkspace;
    const payload = {
      workspaceId: workspace.id,
      integrationType: 'JIRA'
    } as IntegrationNs.IntegrationInfoRequest;
    this.integrationStore.loadNotIntegratedProjectsInWorkspace(payload).then((data) => {
      this.allWorkspaceProjects = [
        {id: -99, name: 'New Blank Project +'} as ProjectNs.Project,
        ...data
      ]
    })
    this.integrationStore.loadAllProjectsToIntegration(payload).then((data) => {
      if (!data || data.length === 0) {
        console.log('No Project Loaded. Try again!')
        this.integrationStore.loadAllProjectsToIntegration(payload)
            .then((data) => {
              this.isLoading = false
              this.jiraProjectList = data
            })
      } else {
        this.isLoading = false
        this.jiraProjectList = data
      }
    })
  },
  methods: {
    clickContinue() {
      if (!this.selectedMSProject || !this.selectedJiraProject) {
        return
      }

      const payload = {
        projectKey: this.selectedJiraProject.key,
        msProjectId: this.selectedMSProject.id
      } as any

      this.$emit('continueClick', payload)
    }
  }
})
</script>
<style lang="scss" scoped>
.loading-list {
  padding: var(--space-16);
  font-size: var(--fs-14);
}
</style>
